import * as React from "react";
import {
  registerExpirationListener,
  unregisterExpirationListener
} from "../../api/instance";

import { isValid, me } from "../../api/auth";

import { useHistory } from "react-router-dom";

import { useUser } from "../../UserProvider";

const EXPIRATION_INTERVAL = 30000;

const DEFAULT_REDIRECT_TO = "/login";

type SessionManagerProps = {
  children: any;
  redirectTo?: string;
};

function SessionManager({ children, redirectTo }: SessionManagerProps) {
  const history = useHistory();
  const { setUser } = useUser();

  const handleExpired = () => {
    history.push(redirectTo || DEFAULT_REDIRECT_TO);
    setUser(null);
  };

  const checkExpiration = React.useCallback(() => {
    isValid().catch(handleExpired);
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    // didMount
    const intervalId = setInterval(checkExpiration, EXPIRATION_INTERVAL);
    const apiListener = registerExpirationListener(handleExpired);

    // on unmount
    return () => {
      clearInterval(intervalId);
      unregisterExpirationListener(apiListener);
    };
    // eslint-disable-next-line
  }, []);

  return children;
}

type Props = {
  redirectTo?: string;
  children: any;
};

function Protect({ children, redirectTo }: Props) {
  const [isValidating, setValidating] = React.useState(true);
  const history = useHistory();
  const { setUser, user } = useUser();

  React.useEffect(() => {
    isValid()
      .then(() => {
        if (!user) {
          return me().then(result => {
            setUser(result);
            setValidating(false);
          });
        } else {
          setValidating(false);
        }
      })
      .catch(() => {
        history.replace(redirectTo || DEFAULT_REDIRECT_TO);
        setUser(null);
      });
    // eslint-disable-next-line
  }, []);

  if (isValidating) {
    return null;
  }

  return <SessionManager redirectTo={redirectTo}>{children}</SessionManager>;
}

export default Protect;
